import { MarkerClusterer } from '@googlemaps/markerclusterer';
import MapMarkerIconCluster from '../../../../publicResources/icons/map-marker-cluster.svg';
import MapMarkerIcon from '../../../../publicResources/icons/map-marker-unselected.svg';
import MapMarkerRoofIcon from '../../../../publicResources/icons/map-marker-roof-unselected.svg';

export const addMarkersAndClusterer = (map, facilities, markerClickHandler, markerLoadHandler, markerMap, clusterer, updateMarkers) => {
  if (!facilities) return;

  const isFacilitySearchPage = document.querySelector('body').classList.contains('facilitysearchpage');
  const getZIndex = (lat) => Math.round((lat - Math.floor(lat)) * -10000);

  const setImage = (icon) => {
    const img = document.createElement('img');
    img.setAttribute('src', icon.url);
    img.setAttribute('height', icon.scaledSize.height);
    img.setAttribute('width', icon.scaledSize.width);
    img.setAttribute('alt', 'marker parking facility');
    return img;
  }

  const removeMarkers = () => {
    for (const [key, value] of Object.entries(markerMap)) {
      value.map = null;
    }

    if (clusterer) clusterer.clearMarkers();
    markerMap = {};
  }

  const addMarkers = () => {
    if ((updateMarkers || !isFacilitySearchPage) && markerMap && Object.keys(markerMap).length > 0) removeMarkers();

    const markers = facilities.map((place, index) => {
      let alreadyExists = false;
      if (markerMap && Object.keys(markerMap).length > 0) {
        for (const [key] of Object.entries(markerMap)) {
          if (key === place.Uid) {
            alreadyExists = true;
            break;
          }
        }
      }

      if (alreadyExists) return;

      const coordinates = {
        lng: place.Address.Marker.Coordinates.lng ?? place.Address.Marker.Coordinates[0],
        lat: place.Address.Marker.Coordinates.lat ?? place.Address.Marker.Coordinates[1],
      };
      const icon = place.Indoor ? { url: MapMarkerRoofIcon, scaledSize: new google.maps.Size(30, 33), anchor: new google.maps.Point(15, 33) } :
        { url: MapMarkerIcon, scaledSize: new google.maps.Size(30, 33), anchor: new google.maps.Point(15, 33) }

      const marker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position: coordinates,
        title: place.Name,
        content: setImage(icon),
        zIndex: getZIndex(coordinates.lat)
      })
      marker.addListener('click', () => markerClickHandler(event, place));
      markerLoadHandler(marker, place, index)
      return marker
    }).filter(marker => marker != undefined);

    if (markers.length) return addClusterer(markers, map);
    else return null
  }

  const addClusterer = (markers, map) => {
    const buildContent = (markers) => {
      const content = document.createElement('div');
      content.classList.add(isFacilitySearchPage ? 'facilitysearchpage__map__cluster-icon' : 'citypage__map__cluster-icon');
      content.innerText = markers.length.toString();

      return content;
    }

    const renderer = {
      render: ({ markers, _position: position }) => {
        return new google.maps.marker.AdvancedMarkerElement({
          map,
          position: position ? {
            lat: position.lat(),
            lng: position.lng(),
          } : null,
          title: markers.length.toString(),
          content: buildContent(markers),
          zIndex: position.lat() && position.lat() > 0 ? getZIndex(position.lat()) : 0,
        });
      }
    };
    return clusterer ? clusterer.addMarkers([...markers, ...clusterer.markers]) : new MarkerClusterer({ markers, map, algorithmOptions: { maxZoom: 14 }, renderer });
  }

  return addMarkers();
}
